module.exports = __webpack_public_path__ + "img/weal_2.96a6677e.jpg";